module.exports = __webpack_public_path__ + "static/img/panel2.15b808f6.png";